import { useLoaderData } from "react-router-dom";
import { vegaView, VEGA_CONFIG, VEGA_HEIGHT, VEGA_WIDTH } from "../vegahelpers";


export default function DistancePerMonth() {
    const data : any = useLoaderData()
    return vegaView(data, ((_) => { return {
        config: VEGA_CONFIG,
        width: VEGA_WIDTH,
        height: VEGA_HEIGHT,
        mark: 'bar',
        title: {
            text: "Distance per Month",
        },
        encoding: {
            x: { field: 'date', type: "temporal", timeUnit:"yearmonth", axis: { title: "Month of Workout", format: "%b %y"}},
            y: { aggregate: "sum", field: "total_distance", axis: { title: "Total Distance (m)", tickMinStep: 1}},
            tooltip: [
                { field: "date", type: "temporal", timeUnit: "yearmonth", title: "Month of", format: "%b %Y" },
                { aggregate: "sum", field: "total_distance", title: "Total distance" },
            ]
        },
        data: { name: 'table' }, 
    }}), null, "Distance includes rest distance.")
}